import React, { useContext, useEffect, useState } from "react";
import "./ProjectsSection.css";
import Card from "./Card";
import Card2 from "./Card2";
import SortIcon from "../../Images/FilterIcon.png";
import "./Modal.css";
import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db } from "../Firebase/firebase";
import "./style.css";
import ReactPaginate from "react-paginate";
import { IconContext } from "react-icons";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai";
import { toast, ToastContainer } from "react-toastify";
import { where } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import ShimmerUiCard from "./ShimmerUiCard";
import ShimmerUiCard2 from "./ShimmerUiCard2";
// Add: Import the FilterContext to access the selected categories
import { FilterContext } from "./FilterContext";
import CompanyDetails from "../ComapanyDetails";
import Magnify from "../../Images/Magnify.png";
import fire from "../../Images/fire.png";
import star from "../../Images/star.svg";
import filterm from "../../Images/filterm.png";
import Sidebar from "./Sidebar";
import FilterMobile from "../../Images/Filtermobile.svg";
import Pcagination from "../Paginantion";
import RightArrow from "../../Images/RightArrow.png";
import MobilePagination from "../mobilepagination";
const cache = {};

const ProjectsSection = () => {
  const [page, setPage] = useState(0);
  const [popPage, setPopPage] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [suggestionList, setSuggestionList] = useState([]);
  const [sortedProjectList, setSortedProjectList] = useState([]);

  const [arr, setarr] = useState(new Array(4).fill(""));
  const [requestSent, setRequestSent] = useState(0);
  const [requestReceived, setRequestReceived] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [sortOptions, setSortOptions] = useState({
    newest: false,
    oldest: false,
    az: false,
    za: false,
  });
  const [userProjectList, setUserProjectList] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [requestReceivedCount, setRequestReceivedCount] = useState(0);
  const [requestSentCount, setRequestSentCount] = useState(0);
  const [sortedPaginatedProjectList, setSortedPaginatedProjectList] = useState(
    []
  );

  const [selectedProject, setSelectedProject] = useState(null); // State to track the selected card

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
const [showShimmer , setShowShimmer] =useState(true)
  const handleFilterOpen = () => {
    setIsMobileFilterOpen(!isMobileFilterOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click happened outside the modal content
      if (isMobileFilterOpen && !event.target.closest(".filterm")) {
        setIsMobileFilterOpen(false);
      }
    };

    // Add the event listener if the modal is open
    if (isMobileFilterOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      // Remove the event listener when the modal closes or on cleanup
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMobileFilterOpen]);

  const toggleFilter = () => {
    setIsFilterOpen(true);
  };

  // Function to handle when a card is clicked
  const handleCardClick = (project) => {
    // Save project data to localStorage or sessionStorage
    localStorage.setItem("selectedProject", JSON.stringify(project));
    console.log("clicked");

    // Open the new page in a new tab
    window.open("/companydetails", "_blank");
  };

  // Add: Use the context to access selected categories
  const {
    selectedCategories,
    selectedEcosystems,
    selectedFundingStages,
    selectedRequestTypes,
    selectedPartenerShipInterests,
    selectedLocation,
    selectedProfileStatus,
  } = useContext(FilterContext);

  //Debounce and AutoSuggestion

  /* const getData = async () => {
    if (cache[searchInput]) {
      setSuggestionList(cache[searchInput]);
    } else {
      const res = await fetch(
        `https://www.google.com/complete/search?client=firefox&q=${searchInput}`
      );
      const data = await res.json();
      //console.log(data[1])
      cache[searchInput] = data[1];
      setSuggestionList(cache[searchInput]);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      getData();
    }, 200);
    return () => clearTimeout(timer);
  }, [searchInput]); */

  // Fetch function to get request counts
  const fetchUserConnectCounts = async (userId) => {
    try {
      const connectsRef = collection(db, "UserConnects");

      // Queries to match userId and toUserId
      const userQuery = query(connectsRef, where("userId", "==", userId));
      const toUserQuery = query(connectsRef, where("toUserId", "==", userId));

      // Run both queries in parallel
      const [userSnapshot, toUserSnapshot] = await Promise.all([
        getDocs(userQuery),
        getDocs(toUserQuery),
      ]);

      // Return the requestSent and requestReceived counts
      return {
        requestSent: userSnapshot.size,
        requestReceived: toUserSnapshot.size,
      };
    } catch (error) {
      console.error("Error fetching user connect counts:", error);
      return { requestSent: 0, requestReceived: 0 }; // Default in case of error
    }
  };
  useEffect(() => {
    const sortProjectsByRequestReceived = async () => {
      // Clone the array to avoid mutating the original
      const updatedList = await Promise.all(
        userProjectList.map(async (project) => {
          // Fetch request counts for each user
          const { requestSent, requestReceived } = await fetchUserConnectCounts(
            project.userId
          );

          // Return the updated project object with requestSent and requestReceived
          return {
            ...project,
            requestSent,
            requestReceived,
          };
        })
      );

      // Sort the updated list by requestReceived in descending order
      updatedList.sort((a, b) => b.requestReceived - a.requestReceived);

      // Update the state with the sorted list
      setSortedProjectList(updatedList);
    };

    // Call the function to sort projects
    sortProjectsByRequestReceived();
  }, [userProjectList]);

  // Fetch the user projects from Firestore
  /* const fetchUserProjectData = async () => {
    try {
      const UserProjectQuery = query(collection(db, "UserProject"));
      const userProjectQuerySnapshot = await getDocs(UserProjectQuery);
      if (userProjectQuerySnapshot) {
        const userProject = userProjectQuerySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setUserProjectList(userProject);
      }
    } catch (error) {
      toast.error(error, { position: "top-center" });
    }
  }; */


  const fetchUserProjectData = async () => {
    try {
      const UserProjectQuery = query(collection(db, "UserProject"));
      const userProjectQuerySnapshot = await getDocs(UserProjectQuery);
  
      if (!userProjectQuerySnapshot.empty) {
        // Map through each project and check user verification status
        const userProject = await Promise.all(
          userProjectQuerySnapshot.docs.map(async (doc) => {
            const projectData = doc.data();
            const isVerified = await isUserVerified(projectData); // Check if the associated user is verified
  
            // Only include project data if the user is verified
            if (isVerified) {
              return {
                ...projectData,
                id: doc.id,
              };
            }
  
            return null; // Exclude the project if user is not verified
          })
        );
  
        // Filter out any null values from the array
        const filteredUserProjects = userProject.filter(Boolean);
        setUserProjectList(filteredUserProjects);
      }
    } catch (error) {
      toast.error(error.message || "Error fetching user project data", { position: "top-center" });
    }
  };
  useEffect(() => {
    fetchUserProjectData();
  }, [db]);

  // Fetch Request Received Count
  const fetchRequestReceivedCount = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const receivedQuery = query(
        collection(db, "ConnectionReq"),
        where("toUserId", "==", user.uid)
      );
      const receivedSnapshot = await getDocs(receivedQuery);
      setRequestReceivedCount(receivedSnapshot.size); // Set count of received requests
    }
  };

  // Fetch Request Sent Count
  const fetchRequestSentCount = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const sentQuery = query(
        collection(db, "ConnectionReq"),
        where("fromUserId", "==", user.uid)
      );
      const sentSnapshot = await getDocs(sentQuery);
      setRequestSentCount(sentSnapshot.size); // Set count of sent requests
    }
  };

  useEffect(() => {
    fetchRequestReceivedCount();
    fetchRequestSentCount();
  }, [db]);

  // Update Filter Data when searchInput changes
  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchInput(val);

    if (val) {
      // Filter the projects based on the search input
      const filteredProjects = userProjectList.filter((project) =>
        project.name.toLowerCase().includes(val.toLowerCase())
      );
      setFilterData(filteredProjects);
    } else {
      // Show data for the first page when input is cleared
      setPage(0); // Reset to the first page
      setFilterData(
        userProjectList.filter((item, index) => {
          return index >= 0 && index < n; // Show items for page 1
        })
      );
    }
  };

  //Pagination
  // const n = 10;
  // const [page, setPage] = useState(0);

  // const [popPage,setPopPage]=useState(0);
  const [currentPopularItems, setCurrentPopularItems] = useState([]);

  useEffect(() => {
    setFilterData(
      userProjectList.filter((item, index) => {
        return (index >= page * n) & (index < (page + 1) * n);
      })
    );
  }, [userProjectList, page]);

  useEffect(() => {
    setSortedPaginatedProjectList(
      sortedProjectList.filter((item, index) => {
        return (index >= popPage * 4) & (index < (popPage + 1) * 4);
      })
    );
  }, [sortedProjectList, popPage]);

  const n = 10;
  const itemsPerPopPage = 4; // Number of items per page for popPage

  useEffect(() => {
    setFilterData(
      userProjectList.filter((item, index) => {
        return index >= page * n && index < (page + 1) * n;
      })
    );
  }, [userProjectList, page]);

  useEffect(() => {
    setSortedPaginatedProjectList(
      sortedProjectList.filter((item, index) => {
        return (
          index >= popPage * itemsPerPopPage &&
          index < (popPage + 1) * itemsPerPopPage
        );
      })
    );
  }, [sortedProjectList, popPage]);

  const handlePageChange = (page) => {
    setPage(page - 1); // Adjust for 0-based index
  };

  const handlePopPageChange = (page) => {
    setPopPage(page - 1); // Adjust for 0-based index
  };

  const handleSortChange = (e) => {
    const { name, checked } = e.target;
    setSortOptions({ ...sortOptions, [name]: checked });
  };

  const applySorting = () => {
    let sortedList = [...filterData];
    if (sortOptions.newest) {
      sortedList.sort((a, b) => b.createdAt - a.createdAt);
    }
    if (sortOptions.oldest) {
      sortedList.sort((a, b) => a.createdAt - b.createdAt);
    }
    if (sortOptions.az) {
      sortedList.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (sortOptions.za) {
      sortedList.sort((a, b) => b.name.localeCompare(a.name));
    }

    setFilterData(sortedList);
    /* setShowModal(false); */
  };

  useEffect(() => {
    applySorting();
  }, [sortOptions]);

  //FilterCategory
  /*  useEffect(() => {
    // Add: Handle logic to display default data when no category is selected
    if (selectedCategories.length === 0) { 
      setPage(page); // Reset to the first page
      
      setFilterData(
        userProjectList.filter((item, index) => {
          return (index >= page * n) & (index < (page + 1) * n);
        })
      );
    } else {
      // Add: Filter projects based on selected categories
      const filteredProjects = userProjectList.filter((project) => 
        selectedCategories.includes(project.category) 
      );
      setFilterData(filteredProjects);
    }
  }, [userProjectList, selectedCategories, page]); */
  /* useEffect(() => {
    const filteredProjects = userProjectList.filter((project) => {
      const categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(project.category);
      const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.includes(project.blockchain);
      const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.includes(project.fundingStatus);
      const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.includes(project.requestType);
      //const profileStatusMatch = selectedProfileStatus.length === 0 || selectedProfileStatus.includes(project.);
      const locationMatch = selectedLocation.length === 0 || selectedLocation.includes(project.country);
      const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.includes(project.partnershipInterest);
     
      return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch
    });
  
    setFilterData(
      filteredProjects.filter((item, index) => {
        return (index >= page * n) & (index < (page + 1) * n);
      })
    );
  }, [userProjectList, selectedCategories, selectedEcosystems,selectedFundingStages,selectedRequestTypes,selectedPartenerShipInterests,selectedLocation,selectedProfileStatus, page, n]); */

  /* useEffect(() => {
    const fetchVerifiedStatus = async () => {
      const userIds = userProjectList.map((project) => project.userId);
      
      // Check if userIds array is empty
      if (userIds.length === 0) {
        // If there are no user IDs, skip Firestore query and filter projects without profile status match
        const filteredProjects = userProjectList.filter((project) => {
          const categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(project.category);
          const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.includes(project.blockchain);
          const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.includes(project.fundingStatus);
          const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.includes(project.requestType);
          const locationMatch = selectedLocation.length === 0 || selectedLocation.includes(project.country);
          const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.includes(project.partnershipInterest);
  
          // Skip profile status check when there are no user IDs
          return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch;
        });
  
        setFilterData(
          filteredProjects.filter((item, index) => {
            return index >= page * n && index < (page + 1) * n;
          })
        );
        return; // Exit early if there are no user IDs
      }
  
      const userVerificationStatus = {};
      const tguserVerificationStatus={};
  
      try {
        // Perform Firestore query only if userIds array is not empty
        const usersSnapshot = await getDocs(
          query(collection(db, 'User'), where('id', 'in', userIds))
        );
        
  
        usersSnapshot.forEach((doc) => {
          const userData = doc.data();
         
          userVerificationStatus[userData.id] = userData.verified;
          tguserVerificationStatus[userData.id]=userData. tgVerified;
        });
  
        const filteredProjects = userProjectList.filter((project) => {
          const categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(project.category);
          const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.includes(project.blockchain);
          const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.includes(project.fundingStatus);
          const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.includes(project.requestType);
          const locationMatch = selectedLocation.length === 0 || selectedLocation.includes(project.country);
          const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.includes(project.partnershipInterest);
  
          // Check profile status for Email Verified
          const profileStatusMatch = selectedProfileStatus.length === 0 ||
            (selectedProfileStatus.includes("Email Verified") 
              ? userVerificationStatus[project.userId] === true 
              : true);
  
          return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch && profileStatusMatch;
        });
  
        // Apply pagination filter after filtering projects
        setFilterData(
          filteredProjects.filter((item, index) => {
            return index >= page * n && index < (page + 1) * n;
          })
        );
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
  
    fetchVerifiedStatus(); // Fetch and filter projects based on verification status
  }, [
    userProjectList, 
    selectedCategories, 
    selectedEcosystems,
    selectedFundingStages, 
    selectedRequestTypes, 
    selectedPartenerShipInterests, 
    selectedLocation, 
    selectedProfileStatus, 
    page, 
    n
  ]); */

  /* useEffect(() => {
    const fetchVerifiedStatus = async () => {
        const userIds = userProjectList.map((project) => project.userId);
        
        // Check if userIds array is empty
        if (userIds.length === 0) {
            // If there are no user IDs, skip Firestore query and filter projects without profile status match
            const filteredProjects = userProjectList.filter((project) => {
                const categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(project.category);
                const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.includes(project.blockchain);
                const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.includes(project.fundingStatus);
                const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.includes(project.requestType);
                const locationMatch = selectedLocation.length === 0 || selectedLocation.includes(project.country);
                const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.includes(project.partnershipInterest);
    
                // Skip profile status check when there are no user IDs
                return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch;
            });
    
            setFilterData(
                filteredProjects.filter((item, index) => {
                    return index >= page * n && index < (page + 1) * n;
                })
            );
            return; // Exit early if there are no user IDs
        }
    
        const userVerificationStatus = {};
        const tgUserVerificationStatus = {};
    
        try {
            // Perform Firestore query only if userIds array is not empty
            const usersSnapshot = await getDocs(
                query(collection(db, 'User'), where('id', 'in', userIds))
            );
            
    
            usersSnapshot.forEach((doc) => {
                const userData = doc.data();
               
                userVerificationStatus[userData.id] = userData.verified;
                tgUserVerificationStatus[userData.id] = userData.tgVerified;
            });
    
            const filteredProjects = userProjectList.filter((project) => {
                const categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(project.category);
                const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.includes(project.blockchain);
                const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.includes(project.fundingStatus);
                const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.includes(project.requestType);
                const locationMatch = selectedLocation.length === 0 || selectedLocation.includes(project.country);
                const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.includes(project.partnershipInterest);
    
                // Check profile status for both Email Verified and TG Verified
                const profileStatusMatch = selectedProfileStatus.length === 0 || 
                    (selectedProfileStatus.includes("Email Verified") 
                        ? userVerificationStatus[project.userId] === true 
                        : true) &&
                    (selectedProfileStatus.includes("TG Verified") 
                        ? tgUserVerificationStatus[project.userId] === true 
                        : true);
    
                return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch && profileStatusMatch;
            });
    
            // Apply pagination filter after filtering projects
            setFilterData(
                filteredProjects.filter((item, index) => {
                    return index >= page * n && index < (page + 1) * n;
                })
            );
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };
  
    fetchVerifiedStatus(); // Fetch and filter projects based on verification status
}, [
    userProjectList, 
    selectedCategories, 
    selectedEcosystems,
    selectedFundingStages, 
    selectedRequestTypes, 
    selectedPartenerShipInterests, 
    selectedLocation, 
    selectedProfileStatus, 
    page, 
    n
]); */

  /* useEffect(() => {
  const fetchVerifiedStatus = async () => {
      const userIds = userProjectList.map((project) => project.userId);

      // Check if userIds array is empty
      if (userIds.length === 0) {
          // If there are no user IDs, skip Firestore query and filter projects without profile status match
          const filteredProjects = userProjectList.filter((project) => {

              const categoryMatch = selectedCategories.length === 0 || selectedCategories.some((category) => (project.category || []).includes(category));
              const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.some((ecosystem) => (project.blockchain || []).includes(ecosystem));
              const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.some((stage) => (project.fundingStatus || []).includes(stage));
              const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.some((type) => (project.requestType || []).includes(type));
              const locationMatch = selectedLocation.length === 0 || selectedLocation.some((location) => (project.country || []).includes(location));

              const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.some((interest) => (project.partnershipInterest || []).includes(interest));


              // Skip profile status check when there are no user IDs
              return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch;
          });

          setFilterData(
              filteredProjects.filter((item, index) => {
                  return index >= page * n && index < (page + 1) * n;
              })
          );
          return; // Exit early if there are no user IDs
      }

      const userVerificationStatus = {};
      const tgUserVerificationStatus = {};

      try {
          // Perform Firestore query only if userIds array is not empty
          const usersSnapshot = await getDocs(
              query(collection(db, 'User'), where('id', 'in', userIds))
          );

          usersSnapshot.forEach((doc) => {
              const userData = doc.data();
              userVerificationStatus[userData.id] = userData.verified;
              tgUserVerificationStatus[userData.id] = userData.tgVerified;
          });

          const filteredProjects = userProjectList.filter((project) => {

              const categoryMatch = selectedCategories.length === 0 || selectedCategories.some((category) => (project.category || []).includes(category));
              const ecosystemMatch = selectedEcosystems.length === 0 || selectedEcosystems.some((ecosystem) => (project.blockchain || []).includes(ecosystem));
              const fundingstageMatch = selectedFundingStages.length === 0 || selectedFundingStages.some((stage) => (project.fundingStatus || []).includes(stage));
              const requesttypeMatch = selectedRequestTypes.length === 0 || selectedRequestTypes.some((type) => (project.requestType || []).includes(type));
              const locationMatch = selectedLocation.length === 0 || selectedLocation.some((location) => (project.country || []).includes(location));
              const partnershipinterestMatch = selectedPartenerShipInterests.length === 0 || selectedPartenerShipInterests.some((interest) => (project.partnershipInterest || []).includes(interest));


              // Check profile status for both Email Verified and TG Verified
              const profileStatusMatch = selectedProfileStatus.length === 0 || 
                  (selectedProfileStatus.includes("Email Verified") 
                      ? userVerificationStatus[project.userId] === true 
                      : true) &&
                  (selectedProfileStatus.includes("TG Verified") 
                      ? tgUserVerificationStatus[project.userId] === true 
                      : true);

              return categoryMatch && ecosystemMatch && fundingstageMatch && requesttypeMatch && locationMatch && partnershipinterestMatch && profileStatusMatch;
          });

          // Apply pagination filter after filtering projects
          setFilterData(
              filteredProjects.filter((item, index) => {
                  return index >= page * n && index < (page + 1) * n;
              })
          );
      } catch (error) {
          console.error("Error fetching users:", error);
      }
  };

  fetchVerifiedStatus(); // Fetch and filter projects based on verification status
}, [
  userProjectList, 
  selectedCategories, 
  selectedEcosystems,
  selectedFundingStages, 
  selectedRequestTypes, 
  selectedPartenerShipInterests, 
  selectedLocation, 
  selectedProfileStatus, 
  page, 
  n
]); */
  useEffect(() => {
    const fetchVerifiedStatus = async () => {
      const userIds = userProjectList.map((project) => project.userId);

      // Check if userIds array is empty
      if (userIds.length === 0) {
        // If there are no user IDs, skip Firestore query and filter projects without profile status match
        const filteredProjects = userProjectList.filter((project) => {
          const categoryMatch =
            selectedCategories.length === 0 ||
            selectedCategories.some((category) =>
              (project.category || []).includes(category)
            );
          const ecosystemMatch =
            selectedEcosystems.length === 0 ||
            selectedEcosystems.some((ecosystem) =>
              (project.blockchain || []).includes(ecosystem)
            );
          const fundingstageMatch =
            selectedFundingStages.length === 0 ||
            selectedFundingStages.some((stage) =>
              (project.fundingStatus || []).includes(stage)
            );
          const requesttypeMatch =
            selectedRequestTypes.length === 0 ||
            selectedRequestTypes.some((type) =>
              (project.requestType || []).includes(type)
            );
          const locationMatch =
            selectedLocation.length === 0 ||
            selectedLocation.some((location) =>
              (project.country || []).includes(location)
            );

          const partnershipinterestMatch =
            selectedPartenerShipInterests.length === 0 ||
            selectedPartenerShipInterests.some((interest) =>
              (project.partnershipInterest || []).includes(interest)
            );

          // Skip profile status check when there are no user IDs
          return (
            categoryMatch &&
            ecosystemMatch &&
            fundingstageMatch &&
            requesttypeMatch &&
            locationMatch &&
            partnershipinterestMatch
          );
        });

        setFilterData(
          filteredProjects.filter((item, index) => {
            return index >= page * n && index < (page + 1) * n;
          })
        );
        return; // Exit early if there are no user IDs
      }

      const userVerificationStatus = {};
      const tgUserVerificationStatus = {};

      try {
        // Perform Firestore query only if userIds array is not empty
        const usersSnapshot = await getDocs(
          query(collection(db, "User"), where("id", "in", userIds))
        );

        usersSnapshot.forEach((doc) => {
          const userData = doc.data();
          userVerificationStatus[userData.id] = userData.verified;
          tgUserVerificationStatus[userData.id] = userData.tgVerified;
        });

        const filteredProjects = userProjectList.filter((project) => {
          const categoryMatch =
            selectedCategories.length === 0 ||
            selectedCategories.some((category) =>
              (project.category || []).includes(category)
            );
          const ecosystemMatch =
            selectedEcosystems.length === 0 ||
            selectedEcosystems.some((ecosystem) =>
              (project.blockchain || []).includes(ecosystem)
            );
          const fundingstageMatch =
            selectedFundingStages.length === 0 ||
            selectedFundingStages.some((stage) =>
              (project.fundingStatus || []).includes(stage)
            );
          const requesttypeMatch =
            selectedRequestTypes.length === 0 ||
            selectedRequestTypes.some((type) =>
              (project.requestType || []).includes(type)
            );
          const locationMatch =
            selectedLocation.length === 0 ||
            selectedLocation.some((location) =>
              (project.country || []).includes(location)
            );
          const partnershipinterestMatch =
            selectedPartenerShipInterests.length === 0 ||
            selectedPartenerShipInterests.some((interest) =>
              (project.partnershipInterest || []).includes(interest)
            );

          // Check profile status for both Email Verified and TG Verified
          const profileStatusMatch =
            selectedProfileStatus.length === 0 ||
            ((selectedProfileStatus.includes("Email Verified")
              ? userVerificationStatus[project.userId] === true
              : true) &&
              (selectedProfileStatus.includes("TG Verified")
                ? tgUserVerificationStatus[project.userId] === true
                : true));

          return (
            categoryMatch &&
            ecosystemMatch &&
            fundingstageMatch &&
            requesttypeMatch &&
            locationMatch &&
            partnershipinterestMatch &&
            profileStatusMatch
          );
        });

        // Apply pagination filter after filtering projects
        setFilterData(
          filteredProjects.filter((item, index) => {
            return index >= page * n && index < (page + 1) * n;
          })
        );
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchVerifiedStatus(); // Fetch and filter projects based on verification status
  }, [
    userProjectList,
    selectedCategories,
    selectedEcosystems,
    selectedFundingStages,
    selectedRequestTypes,
    selectedPartenerShipInterests,
    selectedLocation,
    selectedProfileStatus,
    page,
    n,
  ]);

  async function isUserVerified(ele) {
    try {
      // Get the document reference for the user with the given userId
      const userDocRef = collection(db, "User");
      const q1 = query(userDocRef, where("id", "==", ele.userId));
  
      // Fetch the document
      const userDocSnapshot = await getDocs(q1);
  
      // Check if the document exists and if the verified field is true
      if (!userDocSnapshot.empty) {
        const userDoc = userDocSnapshot.docs[0]; // Get the first document (assuming userId is unique)
        if (userDoc.data().verified === true) {
          return true;
        }
      }
  
      return false; // Either document doesn't exist or verified is not true
    } catch (error) {
      console.error("Error fetching user verification status:", error);
      return false; // Return false in case of an error
    }
  }

  const totalPages = Math.ceil(userProjectList.length / n); // Total number of pages
  const totalPages1 = Math.ceil(userProjectList.length / 4);
  // Handle page change
  // const handlePageChange = () => {
  //     setPopPage(popPage - 1);

  //     const startOffset = (popPage - 1) * 4;
  //     const endOffset = startOffset + 4;
  //     setCurrentPopularItems(userProjectList.slice(startOffset, endOffset));
  //      };

  const handleallprojectPageChange = () => {
    setPage(page - 1);
  };

  return (
    <div className="projects-section">
      <div className="projectseciton-sub">
        <div className="search-bar">
          <input
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "400",
              color: "#282828",
              backgroundImage: `url(${Magnify})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "12px center", // Increased horizontal position to move the icon right
              backgroundSize: "24px 24px", // Set image size to 24x24
              paddingLeft: "45px", // Adjusted padding to maintain space between the image and the text
              height: "48px", // Adjust height to ensure proper alignment
            }}
            type="text"
            placeholder="Search Project..."
            onChange={handleSearch}
          />
        </div>

        <div className="popular-pagination-heading">
          <div className="popular-projects">
            <div className="pp">
              {" "}
              Popular Projects{" "}
              
               <img src={fire} alt='fire'/>
            </div>
          </div>
          <div className="pagination-popular">
            {/* <ReactPaginate
  containerClassName={"pagination"}
  activeClassName={"active"}
  pageClassName={"page-item"}
  onPageChange={(event) => setPopPage(event.selected)}
  breakLabel="..."
  pageCount={Math.ceil(userProjectList.length / n)}
  previousLabel={
    <div className="arrow">
      <IconContext.Provider value={{ color: "#FFFFFF", size: "36px" }}>
        <AiFillLeftCircle />
      </IconContext.Provider>
    </div>
  }
  nextLabel={
    <div className="arrow">
      <IconContext.Provider value={{ color: "#FFFFFF", size: "36px" }}>
        <AiFillRightCircle />
      </IconContext.Provider>
    </div>
  }
/> */}

            {/* <Pcagination
                currentPage={popPage + 1} // Pass 1-based page to Pagination
                totalPages={totalPages1}
                onPageChange={handlePageChange}
            /> */}
            {/* <div className='popular-prjct-desktop-pagination'>
            <Pcagination
            currentPage={popPage + 1} // Pass 1-based index
            totalPages={Math.ceil(sortedProjectList.length / itemsPerPopPage)} // Calculate total pages
            onPageChange={handlePopPageChange} // Handler for 'popPage'
        /></div> */}
            <div className="popular-prjct-mobile-pagination">
              <MobilePagination
                currentPage={popPage + 1} // Pass 1-based index
                totalPages={Math.ceil(
                  sortedProjectList.length / itemsPerPopPage
                )} // Calculate total pages
                onPageChange={handlePopPageChange} // Handler for 'popPage'
              />
            </div>
          </div>
        </div>
        <div className="card-list1">
          {sortedPaginatedProjectList.length > 0
            ? sortedPaginatedProjectList.map((ele, i) => {
                return (
                  <Card
                    onClick={() => handleCardClick(ele)}
                    key={ele.createdAt}
                    name={ele.name}
                    logo={ele.profilePicture}
                    desc={ele.descr}
                    web={ele.website}
                    userId={ele.userId}
                    requestType={ele.requestType}
                  />
                );
              })
            : arr.map((ele, i) => {
                return <ShimmerUiCard />;
              })}
        </div>

        <div className="allprojects-filter-cntainer">
          <p className="ap">
            All Projects {/* <img src={star} alt='star'/> */}{" "}
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
            >
              <rect
                y="0.600098"
                width="24"
                height="24"
                fill="url(#pattern0_3790_11834)"
              />
              <defs>
                <pattern
                  id="pattern0_3790_11834"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use href="#image0_3790_11834" transform="scale(0.015625)" />
                </pattern>
                <image
                  id="image0_3790_11834"
                  width="64"
                  height="64"
                  href="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </p>

          <div className="filter-sort-container">
            <div className="filters">
              <div className="filterm">
                {/* {!isFilterOpen && <button onClick={() => setIsFilterOpen(true)}>Open Filter</button>}
      <div className={`filter-options ${isFilterOpen ? 'open' : ''}`}>
        <div onClick={() => setIsFilterOpen(false)}>close</div>
        <Sidebar />
      </div> */}
                <img
                  src={FilterMobile}
                  alt="filter-mobile"
                  onClick={handleFilterOpen}
                />
                {isMobileFilterOpen && (
                  <div className="requestmodal-content-dashboard">
                    <Sidebar />
                  </div>
                )}
              </div>
            </div>
            <div className="filter-container">
              {/* The clickable image */}

              <div className="filter-icon">
                <div
                  onClick={() => setShowModal(!showModal)}
                  style={{
                    cursor: "pointer",
                    fontSize: "2rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img className="sort-img" src={SortIcon} alt="sort-list" />
                </div>
              </div>

              {/* The modal appearing beside the image */}
              {showModal && (
                <div className="filtermodal-content">
                  {/* <h4>Sort Options</h4> */}
                  <label className="checkbox-label">
                    <input
                      className="input-project-section-checkbox"
                      type="checkbox"
                      name="newest"
                      checked={sortOptions.newest}
                      onChange={handleSortChange}
                    />
                    Newest First
                  </label>

                  <label className="checkbox-label">
                    <input
                      className="input-project-section-checkbox"
                      type="checkbox"
                      name="oldest"
                      checked={sortOptions.oldest}
                      onChange={handleSortChange}
                    />
                    Oldest First
                  </label>
                  <label className="checkbox-label">
                    <input
                      className="input-project-section-checkbox"
                      type="checkbox"
                      name="az"
                      checked={sortOptions.az}
                      onChange={handleSortChange}
                    />
                    A-Z
                  </label>
                  <label className="checkbox-label">
                    <input
                      className="input-project-section-checkbox"
                      type="checkbox"
                      name="za"
                      checked={sortOptions.za}
                      onChange={handleSortChange}
                    />
                    Z-A
                  </label>
                  {/* <button onClick={applySorting}>Apply Sorting</button> */}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card2list-pagination-all">
          <div className="card2-list">
            {filterData.length > 0
              ? filterData.map((ele, i) => (

                    <Card2
                    onClick={() => handleCardClick(ele)}
                    key={ele.createdAt}
                    name={ele.name}
                    logo={ele.profilePicture}
                    country={ele.country}
                    desc={ele.biodata}
                    userId={ele.userId}
                    category={ele.category}
                    funding={ele.fundingStatus}
                  />
                ))
              : /*  */
                 ( searchInput ?(<h3>It seems we couldn't find any projects matching your search. Try refining your keywords or explore other sections of our platform.</h3>):(arr.map((ele, i) => {
             
                  return <ShimmerUiCard2 />;
                })) )
                
                }
          </div>

          <div className="pagination-all-projects">
            {/* <Pcagination
                currentPage={page + 1} // Pass 1-based page to Pagination
                totalPages={totalPages}
                onPageChange={handleallprojectPageChange}
            /> */}

         {/*   {!searchInput && ( */} <div className="allproject-pagination">
              <Pcagination
                currentPage={page + 1} // Pass 1-based index
                totalPages={Math.ceil(userProjectList.length / n)} // Calculate total pages
                onPageChange={handlePageChange} // Handler for 'page'
              />
            </div>{/* ) } */}
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default ProjectsSection;
